export enum SymbolSfx {
  /** EUCP with lump-sum interest rather than discount price */
  EUCPWithLumpSumInterest = 'CD',
  /** "When Issued" for a security to be reissued under an old CUSIP or ISIN */
  WhenIssued = 'WI',
}
